// extracted by mini-css-extract-plugin
module.exports = {"wrap":"G7av","imgBg":"G7abf","image":"G7ob","labels":"G7abl","textBox":"G7abh","title":"G7al","subtitle":"G7x3","statistic":"G7a5","advLabel":"G7kh"};